export default __webpack_public_path__ + "static/media/Swift.cc4dcc87.png";